let thumbindex = 0;
let lochash = 0;
let move = 0;
$('document').ready( function(){
  $('.product__thumb').click( function(){
    thumbindex = $(this).attr('data-index');
    location.hash = '#!media'+thumbindex;
  });
  if(window.location.hash){
    lochash = window.location.hash;
    thumbindex = lochash.replace('#!media','');
    $('.product-main-slide').removeClass('is-selected');
    move = Math.round(0-(thumbindex*100))+'%';
    console.log(move);
    $('.flickity-slider').css({'transform':'translateX('+move+')'});
    $('.product-main-slide[data-index="'+thumbindex+'"]').addClass('is-selected');
    $('.product__thumb').removeClass('is-active');
    $('.product__thumb[data-index="'+thumbindex+'"]').addClass('is-active');
  }
});